<template>
  <div>
    <vs-collapse acordion v-if="isExpandable(menuItem)">
      <vs-collapse-item>
        <div slot="header">
          <vs-icon :icon="menuItem.icon"></vs-icon>
          {{ menuItem.text }}
        </div>
        <div class="vs-sidebar--item"
           v-if="canView(menuItem)"
           v-for="(menuItemChild, index) in menuItem.children"
           v-bind:key="index">
          <router-link :to="menuItemChild.route.path">
            <vs-icon v-if="!menuItemChild.icon" :icon="menuItemChild.icon"/>
            {{ menuItemChild.text }}
          </router-link>
        </div>
      </vs-collapse-item>
    </vs-collapse>

    <div class="vs-sidebar--item" v-else-if="canView(menuItem)">
      <router-link :to="menuItem.route.path">
        <vs-icon :icon="menuItem.icon"/>
        {{ menuItem.text }}
      </router-link>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "SideBarRouteItem",
  props: {
    menuItem: {
      required: true
    }
  },
  computed: {
    ...mapState("menu", ["rolesOfUser"]),
  },
  methods: {
    isExpandable(menuItem) {
      return typeof menuItem.children === 'object' && menuItem.children.length > 0;
    },
    canView(menuItem) {
      if (menuItem.route.permissions) {
        const result = menuItem.route.permissions.filter((role) => {
          return this.rolesOfUser.includes(role);
        })
        return result.length > 0;
      }
      return false;
    }
  }
}
</script>

<style>
.vs-sidebar--item {
  padding: 0px;
}
.vs-sidebar--item a:hover {
  text-decoration: none;
}
.vs-sidebar--item a {
  font-size: 1.2rem;
  font-weight: 400;
  text-decoration: none !important;
  padding: 1rem;
  opacity: 1 !important;;
}
.vs-collapse {
  padding: 0px !important;
}
</style>
